import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class MapsService {
  static googleApiKey: string | null = null;

  static readonly googleBasePath = 'https://maps.googleapis.com/maps/api/js';

  private loadMap$: Observable<boolean> | null = null;

  constructor(private httpClient: HttpClient) {}

  load(): Observable<boolean> {
    if (!this.loadMap$) {
      this.loadMap$ = this.httpClient
        .jsonp(
          `${MapsService.googleBasePath}?key=${MapsService.googleApiKey}&libraries=visualization,geometry,drawing,places`,
          'callback'
        )
        .pipe(
          map(() => true),
          catchError((error) => {
            console.error('Failed to load Google Maps API:', error);
            return of(false);
          }),
          shareReplay(1)
        );
    }
    return this.loadMap$;
  }

  static getDirectionsRequestFromLocationsArray(
    locations: google.maps.LatLng[] | undefined
  ): google.maps.DirectionsRequest | undefined {
    if (locations && locations.length) {
      const waypoints: google.maps.DirectionsWaypoint[] =
        locations.length > 2
          ? [...locations].slice(1, locations.length - 1).map((item) => ({ location: item, stopover: true }))
          : [];

      return {
        origin: locations[0],
        destination: locations[locations.length - 1],
        waypoints: waypoints,
        travelMode: google.maps.TravelMode.DRIVING,
      };
    } else {
      return undefined;
    }
  }
}
